import React, { useState, useEffect } from "react";
import StarOutlineIcon from "@material-ui/icons/StarOutline";
import styled from "styled-components";
import Image from "../../../assets/z.jfif";
import Xave from "../../../assets/save.svg";
import share from "../../../assets/ss.svg";
import info from "../../../assets/u.svg";
import like from "../../../assets/like.svg";
import unlike from "../../../assets/Vector.svg";
import { db, auth } from "../../../firebase";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import bookmark from "../../../assets/bookmark.png";
import SignInDialog from "./SignInDialog";

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  FacebookMessengerShareButton,
  PinterestShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  LinkedinIcon,
  PinterestIcon,
  WhatsappIcon,
  TelegramIcon,
  TwitterIcon,
} from "react-share";
import { ButtonGroup } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const Profile = ({
  title,
  Category,
  Date_c,
  D_Name,
  LikeCount,
  click,
  Tofollow,
  followcount,
  readc,
  postid,
  uid,
  puid,
  prof,
  view_prof,
}) => {
  const classes = useStyles();
  const [following, setfollowing] = useState(false);
  const [liked, setliked] = useState(false);
  const [btnText, setbtnText] = useState("Follow");
  const [open, setOpen] = React.useState(false);
  const [url, seturl] = useState(false);
  const [bookmarkURL, setbookmarkURL] = useState(false);
  const [save, setsave] = useState(false);
  const [openDialog, setopenDialog] = useState(false);

  useEffect(() => {
    if (auth.currentUser !== null) {
      const userRef = db.collection("users").doc(uid);
      userRef.get().then((doc) => {
        if (doc.data().saved.includes(postid)) {
          setsave(true);
          console.log("ok");
        }
      });

      const userRef3 = db.collection("posts").doc(postid);
      userRef3.get().then((doc) => {
        if (doc.data().liked_By.includes(uid)) {
          setliked(true);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (puid) {
      const userRef2 = db.collection("users").doc(puid);
      userRef2.get().then((doc) => {
        if (doc.data().follower.includes(uid)) {
          setbtnText("Following");
          setfollowing(true);
          console.log("ok");
        }
      });
    }
  }, [puid]);

  // useEffect(() => {
  //     db.collection('users').doc(uid).get().then(
  //         doc => {setsave(doc.data().saved.includes(postid) ? true : false)}
  //     )
  // }, [])
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  function changeFollowing() {
    if (auth.currentUser === null) {
      setopenDialog(true);
    } else {
      Tofollow();

      if (following) {
        setbtnText("Follow");
        setfollowing(false);
      } else {
        setbtnText("Following");
        setfollowing(true);
      }
    }
  }
  function changeLike() {
    if (auth.currentUser === null) {
      setopenDialog(true);
    } else {
      click();
      if (liked) {
        setliked(false);
      } else {
        setliked(true);
      }
    }
  }

  console.log(save, "save");
  var saveId = [];
  const changeSaved = async (id) => {
    const uid = JSON.parse(localStorage.getItem("user"))["uid"];
    // setpass(!pass);
    db.collection("users")
      .doc(uid)
      .get()
      .then((doc) => {
        saveId = doc.data().saved;
        let arr = [...saveId];
        if (arr.indexOf(id) > -1) {
          arr = arr.filter((e) => e !== id);
          setsave(false);

          db.collection("users").doc(uid).update({ saved: arr });
        } else {
          arr.push(id);

          db.collection("users").doc(uid).update({ saved: arr });
          setsave(true);
        }
      });
  };
  function changeSave() {
    if (auth.currentUser === null) {
      setopenDialog(true);
    } else {
      changeSaved(postid);
    }
  }

  return (
    <>
      <Info>
        <Title>{title}</Title>
        <Links>

          <Iconsmd>
            <Like
              onClick={changeLike}
              src={liked ? like : unlike}
              liked={liked}
            />
            <Icon
              src={save ? bookmark : Xave}
              onClick={changeSave}
              bookmark={bookmark}
              Xave={Xave}
              save={save}
            />
            {/* <Icon/> */}
            <IconX onClick={handleOpen} />
          </Iconsmd>

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <div className={classes.paper}>
                <FacebookShareButton url={window.location.href}>
                  <FacebookIcon round={true} />
                </FacebookShareButton>
                <EmailShareButton url={window.location.href}>
                  <EmailIcon round={true} />
                </EmailShareButton>
                <FacebookMessengerShareButton url={window.location.href}>
                  <FacebookMessengerIcon round={true} />
                </FacebookMessengerShareButton>
                <PinterestShareButton url={window.location.href}>
                  <PinterestIcon round={true} />
                </PinterestShareButton>
                <LinkedinShareButton url={window.location.href}>
                  <LinkedinIcon round={true} />
                </LinkedinShareButton>
                <WhatsappShareButton url={window.location.href}>
                  <WhatsappIcon round={true} />
                </WhatsappShareButton>
                <TelegramShareButton url={window.location.href}>
                  {" "}
                  <TelegramIcon round={true} />
                </TelegramShareButton>
                <TwitterShareButton url={window.location.href}>
                  <TwitterIcon round={true} />
                </TwitterShareButton>
              </div>
            </Fade>
          </Modal>
          <div style={{ width: "100%" }}>
            <IconY style={{ float: "right" }} />

          </div>
        </Links>

        <Tab>
          <Stat>
            Reads <Span>{readc}</Span>
          </Stat>
          <Stat>
            Recommendations<Span>{LikeCount}</Span>
          </Stat>
          <Stat style={{ width: "min-content" }}>
            Category
            <Span>{Category}</Span>
          </Stat>
          <Stat >
            Published <Span>{Date_c}</Span>
          </Stat>
        </Tab>

        <DetailInfo>
          {/* Image */}
          <Avatar
            pic={prof}
            onClick={() => view_prof(puid)}
            style={{ cursor: "pointer" }}
          />
          {/* Name */}
          <NameInfo>
            <Name>{D_Name}</Name>

            <Rating>
              {followcount} Followers
            </Rating>
          </NameInfo>
          {/* Button */}
          <div >
            {uid === puid ? (
              <Button
                onClick={() => view_prof(puid)}
              >
                View Profile
              </Button>
            ) : (
              <Button onClick={changeFollowing}>
                {btnText}
              </Button>
            )}
          </div>

          {/* Links */}
        </DetailInfo>
      </Info>

      {openDialog ? (
        <SignInDialog
          open={true}
          from={"Profile"}
          setopenDialog={setopenDialog}
        />
      ) : null}
    </>
  );
};
// =====================Styling components==================================
const Info = styled.div`
  display: flex;
  margin: 61px 40px 0px 30px;
  flex-direction: column;
  width: 36.73%;
  @media (max-width: 1145px){
    margin: 61px 30px 0px 30px;
    width: 38%;
  };
  @media (max-width: 1000px){
    margin: 61px 20px 0px 20px;
    width: 41%;
  };
  @media (max-width: 815px){
    margin: 30px 0px 0px 0px;
    width: 100%;
    padding: 0 60px;
  };
  @media (max-width: 620px){
    padding: 0 20px;
  };
  @media (max-width: 450px){
    width: 100%;
    padding: 0 10px;
    };
    // @media (max-width: 338px){
    //   width: 95%;
    //   };
`;

const Title = styled.div`
font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 25px;
line-height: 30px;
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 2;
word-break: break-word;
@media (max-width: 1000px){
  font-size: 22px;
}
@media (max-width: 815px){
  text-align: center;
}
`;

const Iconsmd = styled.div`
display: flex;
align-items: center;
@media (max-width: 815px){
  position: absolute;
  margin: 0 0 0 -60px;
  width: 100%;
  justify-content: center;
}
@media (max-width: 620px){
  margin: 0 0 0 -20px;
}
@media (max-width: 450px){
  margin: 0 0 0 -10px;
}

`;

const Links = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;  
  width: 100%;
  align-items: center;
  @media (max-width: 815px){
    text-align: center;
  }
`;

const Like = styled.img`
width: 23px;
margin: 0px 30px 0 0px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 1000px){
    width: 20px;
  }
`;
const Icon = styled.img.attrs((props) => ({
  // src: props.save ? props.Xave : props.bookmark
}))`
  height: ${(props) => (props.save ? "17.875px" : "22px")};
  margin-right: 30px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 1000px){
    height: 18px;
  }
`;
const IconX = styled.img.attrs((props) => ({
  src: share,
}))`
  height: 22.85px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 1000px){
    height: 18px;
  }
`;
const IconY = styled.img.attrs((props) => ({
  src: info,
}))`
  height: 27px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 1000px){
    height: 22px;
  }
`;

const Tab = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 50px;
  width: 100%;
`;
const Stat = styled.div`
  display: flex;
  color: #7d7b7b;
  font-family: Rubik;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  text-align: center;
  margin: 0 4px;
  flex-direction: column;
  // justify-content: space-between;
  @media (max-width: 1000px){
  font-size: 12px;
  }
`;

const Span = styled.span`
  margin-top: 9px;
  color: black;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  @media (max-width: 1000px){
    font-size: 13px;
    }
`;
const DetailInfo = styled.div`
display: flex;
flex-direction: row;
  margin-top: 50px;
  align-items: center;
  justify-content: space-between
`;

const Avatar = styled.img.attrs((props) => ({
  src: props.pic,
}))`
  position: absolute;
  height: 55px;
  width: 55px;
  border-radius: 16px;
  @media (max-width: 1000px){
    height: 48px;
    width: 48px;
  }
`;

const NameInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  padding: 7.25px 0px 7.25px 60px;
  @media (max-width: 1000px){
    padding: 6px 0px 6px 50px;
  };
  @media (max-width: 815px){
    padding: 6px 0px 6px 50px;
  };
`

const Name = styled.text`
  font-size: 14px;
  font-family: Rubik;
  font-style: normal;
  font-weight: 600;
  @media (max-width: 1000px){
    font-size: 13px;
  }
  `;
const Rating = styled(Name)`
  font-size: 13px;
  font-weight: normal;
  color: #7d7b7b;
  @media (max-width: 1000px){
    font-size: 11px;
  }
  `;

const Button = styled.button`
  // position: relative;
  width: 160px;
  height: 40px;
  border: none;
  color: white;
  background: #5db0d8;
  border-radius: 18px;
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  // line-height: 2.74vh;
  text-align: center;
  cursor: pointer;
  @media (max-width: 1000px){
    width: 140px;
    height: 35px;
  };
  // @media (max-width: 415px){
  //   width: 130px;
  //   };
`;

// const BookImg = styled.img`
//   height: 2.5vh;
//   width: 1.3vw;
//   position: absolute;
//   margin-right: 4vw;
//   margin-top: 0.3vh;
//   margin-left: 1vw;
// `;

// const Head = styled.p`
//   position: relative;
//   width: 555px;
//   top: 30px;
//   margin-left: 47px;
//   font-family: Rubik;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 25px;
//   line-height: 30px;
//   dispaly: flex;
//   text-overflow: ellipsis;
//   display: -webkit-box;
// `;

// export { Head };
export default Profile;












// import React, { useState, useEffect } from "react";
// import "../../../Profile.css";
// import StarOutlineIcon from "@material-ui/icons/StarOutline";
// import styled from "styled-components";
// import Image from "../../../assets/z.jfif";
// import Xave from "../../../assets/save.svg";
// import share from "../../../assets/ss.svg";
// import info from "../../../assets/u.svg";
// import like from "../../../assets/like.svg";
// import unlike from "../../../assets/Vector.svg";
// import { db, auth } from "../../../firebase";
// import { makeStyles } from "@material-ui/core/styles";
// import Modal from "@material-ui/core/Modal";
// import Backdrop from "@material-ui/core/Backdrop";
// import Fade from "@material-ui/core/Fade";
// import bookmark from "../../../assets/bookmark.png";
// import SignInDialog from "./SignInDialog";

// import {
//   EmailShareButton,
//   FacebookShareButton,
//   LinkedinShareButton,
//   FacebookMessengerShareButton,
//   PinterestShareButton,
//   TelegramShareButton,
//   TwitterShareButton,
//   WhatsappShareButton,
//   EmailIcon,
//   FacebookIcon,
//   FacebookMessengerIcon,
//   LinkedinIcon,
//   PinterestIcon,
//   WhatsappIcon,
//   TelegramIcon,
//   TwitterIcon,
// } from "react-share";
// const useStyles = makeStyles((theme) => ({
//   modal: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   paper: {
//     backgroundColor: theme.palette.background.paper,
//     border: "2px solid #000",
//     boxShadow: theme.shadows[5],
//     padding: theme.spacing(2, 4, 3),
//   },
// }));

// const Profile = ({
//   title,
//   Category,
//   Date_c,
//   D_Name,
//   LikeCount,
//   click,
//   Tofollow,
//   followcount,
//   readc,
//   postid,
//   uid,
//   puid,
//   prof,
//   view_prof,
// }) => {
//   const classes = useStyles();
//   const [following, setfollowing] = useState(false);
//   const [liked, setliked] = useState(false);
//   const [btnText, setbtnText] = useState("Follow");
//   const [open, setOpen] = React.useState(false);
//   const [url, seturl] = useState(false);
//   const [bookmarkURL, setbookmarkURL] = useState(false);
//   const [save, setsave] = useState(false);
//   const [openDialog, setopenDialog] = useState(false);

//   useEffect(() => {
//     if (auth.currentUser !== null) {
//       const userRef = db.collection("users").doc(uid);
//       userRef.get().then((doc) => {
//         if (doc.data().saved.includes(postid)) {
//           setsave(true);
//           console.log("ok");
//         }
//       });

//       const userRef3 = db.collection("posts").doc(postid);
//       userRef3.get().then((doc) => {
//         if (doc.data().liked_By.includes(uid)) {
//           setliked(true);
//         }
//       });
//     }
//   }, []);

//   useEffect(() => {
//     if (puid) {
//       const userRef2 = db.collection("users").doc(puid);
//       userRef2.get().then((doc) => {
//         if (doc.data().follower.includes(uid)) {
//           setbtnText("Following");
//           setfollowing(true);
//           console.log("ok");
//         }
//       });
//     }
//   }, [puid]);

//   // useEffect(() => {
//   //     db.collection('users').doc(uid).get().then(
//   //         doc => {setsave(doc.data().saved.includes(postid) ? true : false)}
//   //     )
//   // }, [])
//   const handleOpen = () => {
//     setOpen(true);
//   };
//   const handleClose = () => {
//     setOpen(false);
//   };
//   function changeFollowing() {
//     if (auth.currentUser === null) {
//       setopenDialog(true);
//     } else {
//       Tofollow();

//       if (following) {
//         setbtnText("Follow");
//         setfollowing(false);
//       } else {
//         setbtnText("Following");
//         setfollowing(true);
//       }
//     }
//   }
//   function changeLike() {
//     if (auth.currentUser === null) {
//       setopenDialog(true);
//     } else {
//       click();
//       if (liked) {
//         setliked(false);
//       } else {
//         setliked(true);
//       }
//     }
//   }

//   console.log(save, "save");
//   var saveId = [];
//   const changeSaved = async (id) => {
//     const uid = JSON.parse(localStorage.getItem("user"))["uid"];
//     // setpass(!pass);
//     db.collection("users")
//       .doc(uid)
//       .get()
//       .then((doc) => {
//         saveId = doc.data().saved;
//         let arr = [...saveId];
//         if (arr.indexOf(id) > -1) {
//           arr = arr.filter((e) => e !== id);
//           setsave(false);

//           db.collection("users").doc(uid).update({ saved: arr });
//         } else {
//           arr.push(id);

//           db.collection("users").doc(uid).update({ saved: arr });
//           setsave(true);
//         }
//       });
//   };
//   function changeSave() {
//     if (auth.currentUser === null) {
//       setopenDialog(true);
//     } else {
//       changeSaved(postid);
//     }
//   }

//   return (
//     <Container>
//       <Info>
//         <div className="title">{title}</div>
//         <Links>
//           <Like
//             onClick={changeLike}
//             src={liked ? like : unlike}
//             liked={liked}
//           />
//           <Icon
//             src={save ? bookmark : Xave}
//             onClick={changeSave}
//             bookmark={bookmark}
//             Xave={Xave}
//             save={save}
//           />
//           {/* <Icon/> */}
//           <IconX onClick={handleOpen} />
//           <Modal
//             aria-labelledby="transition-modal-title"
//             aria-describedby="transition-modal-description"
//             className={classes.modal}
//             open={open}
//             onClose={handleClose}
//             closeAfterTransition
//             BackdropComponent={Backdrop}
//             BackdropProps={{
//               timeout: 500,
//             }}
//           >
//             <Fade in={open}>
//               <div className={classes.paper}>
//                 <FacebookShareButton url={window.location.href}>
//                   <FacebookIcon round={true} />
//                 </FacebookShareButton>
//                 <EmailShareButton url={window.location.href}>
//                   <EmailIcon round={true} />
//                 </EmailShareButton>
//                 <FacebookMessengerShareButton url={window.location.href}>
//                   <FacebookMessengerIcon round={true} />
//                 </FacebookMessengerShareButton>
//                 <PinterestShareButton url={window.location.href}>
//                   <PinterestIcon round={true} />
//                 </PinterestShareButton>
//                 <LinkedinShareButton url={window.location.href}>
//                   <LinkedinIcon round={true} />
//                 </LinkedinShareButton>
//                 <WhatsappShareButton url={window.location.href}>
//                   <WhatsappIcon round={true} />
//                 </WhatsappShareButton>
//                 <TelegramShareButton url={window.location.href}>
//                   {" "}
//                   <TelegramIcon round={true} />
//                 </TelegramShareButton>
//                 <TwitterShareButton url={window.location.href}>
//                   <TwitterIcon round={true} />
//                 </TwitterShareButton>
//               </div>
//             </Fade>
//           </Modal>
//           <IconY />
//         </Links>

//         <Tab>
//           <Stat style={{ marginLeft: "1vw" }}>
//             Reads <Span>{readc}</Span>
//           </Stat>
//           <Stat style={{ marginLeft: "2vw" }}>
//             Recommendations<Span>{LikeCount}</Span>
//           </Stat>
//           <Stat>
//             Category
//             <div className="category">
//               <Span>{Category}</Span>
//             </div>
//           </Stat>
//           <Stat>
//             Published <Span>{Date_c}</Span>
//           </Stat>
//         </Tab>
//         <InfoPro>
//           {/* Image */}
//           <Avatar
//             pic={prof}
//             onClick={() => view_prof(puid)}
//             style={{ cursor: "pointer" }}
//           />
//           {/* Name */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               height: "7vh",
//               marginLeft: "-1vw",
//               zIndex: "-1",
//               width: "24vw",
//             }}
//           >
//             <Name style={{ marginBottom: "7%" }}>{D_Name}</Name>

//             <Rating>
//               &nbsp;{followcount}&nbsp;
//               <span
//                 style={{
//                   fontFamily: "Rubik",
//                   fontWeight: "normal",
//                   color: "#7D7B7B",
//                 }}
//               >
//                 &nbsp;Followers
//               </span>
//             </Rating>
//           </div>
//           {/* Button */}
//           {uid === puid ? (
//             <Button
//               style={{ marginLeft: "-1vw" }}
//               onClick={() => view_prof(puid)}
//             >
//               View Profile
//             </Button>
//           ) : (
//             <Button style={{ marginLeft: "-1vw" }} onClick={changeFollowing}>
//               {btnText}
//             </Button>
//           )}
//           {/* Links */}
//         </InfoPro>
//       </Info>

//       {openDialog ? (
//         <SignInDialog
//           open={true}
//           from={"Profile"}
//           setopenDialog={setopenDialog}
//         />
//       ) : null}
//     </Container>
//   );
// };
// // =====================Styling components==================================
// const Span = styled.span`
//   margin-top: 3vh;
//   color: black;
//   font-family: Rubik;
//   font-style: normal;
//   font-weight: 500;
//   font-size: 16px;
//   line-height: 2.9vh;
// `;
// const Container = styled.div`
//   position: relative;
//   top: 3.18vh;
//   display: flex;
//   flex-direction: column;
//   /* border:2px solid red; */
//   box-sizing: border-box;
//   height: 45.6vh;
// `;
// const Info = styled.div`
//   display: flex;
//   flex-direction: column;
//   /* border:2px solid green; */
// `;
// const InfoPro = styled(Info)`
//   margin-left: 3.44vw;
//   position: relative;
//   top: 22vh;
//   width: 30w;
//   align-items: center;
//   flex-direction: row;
// `;
// const Links = styled.div`
//   display: flex;
//   align-items: "baseline";
//   position: relative;
//   flex-direction: row;
//   justify-content: space-around;
//   top: 6.85vh;
//   left: 2.2vw;
//   width: 14.64vw;
// `;
// const Head = styled.p`
//   position: relative;
//   width: 555px;
//   top: 30px;
//   margin-left: 47px;
//   font-family: Rubik;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 25px;
//   line-height: 30px;
//   dispaly: flex;
//   text-overflow: ellipsis;
//   display: -webkit-box;
// `;
// const Avatar = styled.img.attrs((props) => ({
//   src: props.pic,
// }))`
//   height: 7.91vh;
//   width: 3.8vw;
//   border-radius: 16px;
// `;

// const Name = styled.p`
//   position: relative;
//   left: 1.5vw;
//   font-size: 13px;
//   font-family: Rubik;
//   font-style: normal;
//   font-weight: 600;
//   margin-top: 1vh;
// `;
// const Rating = styled(Name)`
//   font-size: 13px;
//   font-weight: normal;
//   color: #7d7b7b;
//   top: -4vh;
//   left: 1.5vw;
// `;

// const BookImg = styled.img`
//   height: 2.5vh;
//   width: 1.3vw;
//   position: absolute;
//   margin-right: 4vw;
//   margin-top: 0.3vh;
//   margin-left: 1vw;
// `;

// const Button = styled.button`
//   position: relative;
//   width: 11.3vw;
//   height: 5.77vh;
//   border: none;
//   color: white;
//   background: #5db0d8;
//   border-radius: 18px;
//   font-family: Rubik;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 15px;
//   line-height: 2.74vh;
//   text-align: center;
//   cursor: pointer;
// `;
// const Icon = styled.img.attrs((props) => ({
//   // src: props.save ? props.Xave : props.bookmark
// }))`
//   height: ${(props) => (props.save ? "2.5vh" : "2.79vh")};
//   width: 1.27vw;
//   &:hover {
//     cursor: pointer;
//   }
// `;
// const IconX = styled.img.attrs((props) => ({
//   src: share,
// }))`
//   height: 3vh;
//   width: 1.31vw;
//   &:hover {
//     cursor: pointer;
//   }
// `;
// const IconY = styled.img.attrs((props) => ({
//   src: info,
// }))`
//   position: relative;
//   left: 25vw;
//   height: 3.65vh;
//   width: 1.5vw;
//   &:hover {
//     cursor: pointer;
//   }
// `;
// const Like = styled.img`
//   height: 3.2vh;
//   width: 1.61vw;
//   margin-top: -0.1vh;
//   &:hover {
//     cursor: pointer;
//   }
// `;

// const Tab = styled.div`
//   /* border:2px solid orange; */
//   position: relative;
//   top: 13.7vh;
//   width: 40.63vw;
//   margin-left: 0.36vw;
//   display: flex;
//   flex-direction: row;
//   justify-content: space-evenly;
// `;
// const Stat = styled.div`
//   position: relative;
//   display: flex;
//   color: #7d7b7b;
//   font-family: Rubik;
//   font-style: normal;
//   font-weight: 400;
//   font-size: 13px;
//   line-height: 2.28vh;
//   text-align: center;
//   flex-direction: column;
//   justify-content: space-between;
// `;
// export { Container, Head };
// export default Profile;
